import React from 'react';

import { ProductsType } from '../../BatchTicket/components/DynamicAsset/constants';
import { ProductButtonProps } from '../../BatchTicket/components/DynamicButton';

import { CoesButton } from './products/Coes';
import { DirectTreasuryButton } from './products/DirectTreasury';
import { DirectTreasurySellButton } from './products/DirectTreasurySell';
import { EquityButton } from './products/Equity';
import { EquitySellButton } from './products/EquitySell';
import { FixedIncomeButton } from './products/FixedIncome';
import { FixedIncomeSellButton } from './products/FixedIncomeSell';
import { FundsButton } from './products/Funds';
import { FundsSellButton } from './products/FundsSell';

export const DynamicButton: React.FC<ProductButtonProps<ProductsType>> = (props) => {
  switch (props.id) {
    case 'fixedIncome':
      return <FixedIncomeButton {...(props as ProductButtonProps<'fixedIncome'>)} />;

    case 'fixedIncomeSell':
      return <FixedIncomeSellButton {...(props as ProductButtonProps<'fixedIncomeSell'>)} />;

    case 'funds':
      return <FundsButton {...(props as ProductButtonProps<'funds'>)} />;

    case 'fundsSell':
      return <FundsSellButton {...(props as ProductButtonProps<'fundsSell'>)} />;

    case 'directTreasury':
      return <DirectTreasuryButton {...(props as ProductButtonProps<'directTreasury'>)} />;

    case 'directTreasurySell':
      return <DirectTreasurySellButton {...(props as ProductButtonProps<'directTreasurySell'>)} />;

    case 'equity':
      return <EquityButton {...(props as ProductButtonProps<'equity'>)} />;

    case 'equitySell':
      return <EquitySellButton {...(props as ProductButtonProps<'equitySell'>)} />;

    case 'coes':
      return <CoesButton {...(props as ProductButtonProps<'coes'>)} />;

    default:
      return null;
  }
};
